"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Constant = {
  FORM_STATUS: {
    PAUSED: 0,
    COMPLETED: 1,
    NOT_STARTED: 2,
    NOT_ELIGIBLE: 3,
    NOT_READY: 4
  },
  CONTAINER_NAME: {
    PRIMARY_CONSENT: 'Primary Consent',
    ADDITIONAL_CONSENT: 'Additional Consent(s)',
    PROTOCOL_ACTIVITIES: 'Protocol Activities',
    SURVEYS: 'Surveys'
  },
  TOOLTIP: {
    NOT_RECEIVED: 'Not Received by Biobank',
    NOT_SUITABLE: 'Not Suitable for the DNA analysis',
    RECEIVED_AND_SUITABLE: 'Received by Biobank & Suitable for the DNA analysis',
    NPH_AGREED: 'Data Sharing for The Nutrition for Precision Health Study -  Agreed',
    NPH_DECLINED: 'Data Sharing for The Nutrition for Precision Health Study -  Declined',
    NPH_CONSENTED: 'The participant has consented for NPH study.',
    NPH_WITHDRAWN: 'The participant has withdrawn from NPH study.',
    NPH_DEACTIVATED: 'The participant has been deactivated from NPH study.'
  }
};
var _default = Constant;
exports.default = _default;